import Form from './form'
import React, { useState, useLayoutEffect } from 'react'
import { getFeatureSetComponentDetailRoute } from 'api/Product'

export default function FeatureSetComponentEdit (props) {
  const [data, setData] = useState({})
  const { match: { params: { id } } } = props

  useLayoutEffect(() => {
    getFeatureSetComponentDetailRoute(id).then(setData)
  }, [id])
  return (
    <Form { ...props } data={data} />
  )
}
